import * as React from 'react'
import {exhaustive} from '@freckle/exhaustive'
import {type SpacingSizeT} from './../../helpers/size'
import {xxs, xs, sm, md, lg, xlg} from './button-spacer.module.scss'

type Props = {
  children?: React.ReactNode
  addClass?: string
  spacingSize?: SpacingSizeT
}

function ButtonSpacer(props: Props): React.ReactElement<Props> {
  const {children, addClass, spacingSize = 'xs'} = props

  const baseGroupStyle = () => {
    switch (spacingSize) {
      case null:
      case undefined:
        return xs
      case 'xxs':
        return xxs
      case 'xs':
        return xs
      case 'sm':
        return sm
      case 'md':
        return md
      case 'lg':
        return lg
      case 'xlg':
        return xlg
      default:
        return exhaustive(spacingSize)
    }
  }
  const addClassStr = addClass !== null && addClass !== undefined ? addClass : ''

  return <div className={`${baseGroupStyle()} ${addClassStr}`}>{children}</div>
}

export {ButtonSpacer}
